export default {"src":"/_next/static/image/public/images/ic_clinic_pin.00ae7daac21d6c8af4aaf526f8ecf4db.svg","height":32,"width":32};